<template>
  <div class="animated fadeIn" style="padding-bottom: 30px">
    <ValidationObserver v-slot="{ invalid }">
      <b-row>
        <b-col md="12">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="full-width"
          >
            <div slot="header">
              <strong>Edit Delivery Setup</strong>
              <eb-button
                classic="mr-1 btn-primary back-button"
                text="Back"
                @click="(e) => $emit('edit', e)"
              ></eb-button>
            </div>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="state"
                  >
                    <c-input
                      v-if="!checkDefaultState"
                      :inputId="`state`"
                      inputType="text"
                      lableText="State *"
                      v-model="inputObject.state"
                    />
                    <b-form-input
                      v-if="checkDefaultState"
                      :inputId="`AppliedForAllCityStateCatergories`"
                      inputType="text"
                      size="md"
                      value="Applied for all states"
                      readonly
                    >
                    </b-form-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-1"
                      v-model="checkDefaultState"
                      name="checkbox-1"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultState ? "ied" : "y" }} for all states
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="City"
                  >
                    <c-input
                      v-if="!checkDefaultCity"
                      :inputId="`city`"
                      inputType="text"
                      lableText="City *"
                      v-model="inputObject.city"
                    />

                    <b-form-input
                      v-if="checkDefaultCity"
                      :inputId="`AppliedForAllCityStateCatergories`"
                      inputType="text"
                      size="md"
                      value="Applied for all cities"
                      readonly
                    >
                    </b-form-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-2"
                      v-model="checkDefaultCity"
                      name="checkbox-2"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultCity ? "ied" : "y" }} for all cities
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="sourceState"
                  >
                    <c-input
                      :inputId="`sourceState`"
                      v-if="!checkDefaultSourceState"
                      inputType="text"
                      required
                      lableText="Source State *"
                      v-model="inputObject.sourceState"
                    />
                    <b-form-input
                      v-if="checkDefaultSourceState"
                      :inputId="`AppliedForAllCitySourceStateCatergories`"
                      inputType="text"
                      size="md"
                      value="Applied for all source states"
                      readonly
                    >
                    </b-form-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-3"
                      v-model="checkDefaultSourceState"
                      name="checkbox-3"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultSourceState ? "ied" : "y" }} for all
                      source states
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="sourceCity"
                  >
                    <c-input
                      v-if="!checkDefaultSourceCity"
                      :inputId="`sourcecity`"
                      inputType="text"
                      lableText="Source City *"
                      v-model="inputObject.sourceCity"
                    />
                    <b-form-input
                      v-if="checkDefaultSourceCity"
                      :inputId="`AppliedForAllSourceCity`"
                      inputType="text"
                      size="md"
                      value="Applied for all source cities"
                      readonly
                    >
                    </b-form-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                  <div class="mt-1">
                    <b-form-checkbox
                      id="checkbox-4"
                      v-model="checkDefaultSourceCity"
                      name="checkbox-4"
                      :value="true"
                      :unchecked-value="false"
                    >
                      Appl{{ checkDefaultSourceCity ? "ied" : "y" }} for all
                      source cities
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Category"
                  >
                    <eb-select
                      id="catalog-id"
                      label="text"
                      v-model="inputObject.category"
                      :options="catalogList"
                      :selected="inputObject.category"
                      placeholder="Select Category *"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Transportmode"
                  >
                    <eb-select
                      v-model="inputObject.transportMode"
                      :selected="inputObject.transportMode"
                      :options="transportmode"
                      label="label"
                      placeholder="Select Transportmode *"
                    ></eb-select>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="AreaCode"
                  >
                    <c-input
                      :inputId="`AreaCode`"
                      inputType="number"
                      lableText="Area Code"
                      v-model="inputObject.areacode"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Rank"
                  >
                    <c-input
                      inputType="text"
                      lableText="Rank *"
                      v-model="inputObject.rank"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="start-date"
                  >
                    <label for="start-date">Start Date *:</label>
                    <b-input
                      id="start-date"
                      type="date"
                      v-model="inputObject.startDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="end-date"
                  >
                    <label for="end-date">End Date *:</label>
                    <b-input
                      id="end-date"
                      type="date"
                      v-model="inputObject.endDate"
                    ></b-input>
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>

            <b-row v-if="!deliveryPartnerKeyCheck">
              <b-col md="5">
                <div class="form-group">
                  <b-form-checkbox
                    id="checkbox-5"
                    v-model="deliveryByMe"
                    name="checkbox-5"
                    :value="true"
                    class="mt-2"
                    :unchecked-value="false"
                  >
                    Delivery by me
                  </b-form-checkbox>
                </div>
              </b-col>
              <b-col md="5">
                <div class="form-group">
                  <eb-select
                    v-if="!deliveryByMe"
                    v-model="selectDeliveryPartner"
                    :options="deliveryPartnerOptions"
                    label="name"
                    :placeholder="`Select ${setPlaceHolder} *`"
                    :selected="selectDeliveryPartner"
                  ></eb-select>
                </div>
              </b-col>
            </b-row>
            <b-row v-if="deliveryPartnerKeyCheck">
              <strong>Delivery will done by you</strong>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
      <div>
        <h3>Distance Tier</h3>
        <div v-for="(t, idx) in inputObject.distanceTier" :key="idx">
          <b-card
            border-variant="info"
            header-bg-variant="primary"
            header-text-variant="white"
            class="full-width"
          >
            <b-row class="justify-content-end p-1 pb-2">
              <eb-button
                v-if="idx == inputObject.distanceTier.length - 1"
                style="color: white; font-weight: bold; float: right"
                class="mr-2"
                :text="`Create New Distance Tier`"
                @click="onClickaddButton(null, true)"
              ></eb-button>
              <eb-button
                v-if="inputObject.distanceTier.length > 1"
                style="color: white; font-weight: bold; float: right"
                :text="`Remove Distance Tier`"
                @click="onClickaddButton(idx)"
              ></eb-button>
            </b-row>
            <b-row style="background-color: #767bf1" class="m-2">
              <b-col md="4">
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Distance Tier"
                  >
                    <input
                      :id="`tier-name-${idx}`"
                      placeholder=" "
                      type="text"
                      class="input-weight"
                      v-model="inputObject.distanceTier[idx].tier"
                    />
                    <label class="label-weight">Distance Tier Name *</label>
                    <span class="validate-error text-white">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="4">
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Start Range"
                  >
                    <input
                      :id="`start-range-km-${idx}`"
                      placeholder=" "
                      type="number"
                      class="input-weight"
                      v-model="inputObject.distanceTier[idx].from"
                    />
                    <label class="label-weight">Start Range(KM) *</label>
                    <span class="validate-error text-white">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col md="4">
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="End Range"
                  >
                    <input
                      :id="`end-range-km-${idx}`"
                      placeholder=" "
                      type="number"
                      class="input-weight"
                      v-model="inputObject.distanceTier[idx].to"
                    />
                    <label class="label-weight">End Range(KM) *</label>
                    <span class="validate-error text-white">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
            </b-row>
            <b-row
              v-for="(p, wIdx) in inputObject.distanceTier[idx].weight"
              :key="wIdx"
              class="p-2 m-0"
            >
              <b-col>
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Start range (KG)"
                  >
                    <c-input
                      :inputId="`start-range-kg-${idx}-${wIdx}`"
                      inputType="text"
                      lableText="Start range (KG) *"
                      v-model="inputObject.distanceTier[idx].weight[wIdx].from"
                    />
                    <!-- <input
                      placeholder=" "
                      type="number"
                      class="input-weight"
                      v-model="inputObject.distanceTier[idx].weight[wIdx].from"
                    />
                    <label class=" label-weight">Start range (KG)</label> -->
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col>
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="End range (KG)"
                  >
                    <c-input
                      :inputId="`end-range-kg-${idx}-${wIdx}`"
                      inputType="text"
                      lableText="End range (KG) *"
                      v-model="inputObject.distanceTier[idx].weight[wIdx].to"
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col>
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Custmor Cost"
                  >
                    <c-input
                      :inputId="`customer-cost-${idx}-${wIdx}`"
                      inputType="text"
                      lableText="Customer Cost *"
                      v-model="
                        inputObject.distanceTier[idx].weight[wIdx].customerFee
                      "
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col>
                <div class="material-textfield">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="Delivery Cost"
                  >
                    <c-input
                      :inputId="`delivery-cost-${idx}-${wIdx}`"
                      inputType="text"
                      lableText="Delivery Cost *"
                      v-model="
                        inputObject.distanceTier[idx].weight[wIdx]
                          .deliveryAgentFee
                      "
                    />
                    <span class="validate-error">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </b-col>
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Uom"
                >
                  <eb-select
                    id="catalog-id"
                    style="background-color: white; height: 30px !important"
                    :options="uomList"
                    v-model="inputObject.distanceTier[idx].weight[wIdx].etd.uom"
                    :selected="
                      inputObject.distanceTier[idx].weight[wIdx].etd.uom
                    "
                    class="ml-3"
                    placeholder="Expected *"
                  ></eb-select>
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col>
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="Time"
                >
                  <c-input
                    inputType="text"
                    lableText="Time *"
                    v-model="
                      inputObject.distanceTier[idx].weight[wIdx].etd.time
                    "
                  />
                  <span class="validate-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </b-col>
              <b-col md="2">
                <b-button
                  btn-special="deliverybtn"
                  size="lg"
                  style="backgrount-color: #767bf1"
                  @click="onClickButton(idx, wIdx)"
                >
                  <i
                    class="fa fa-minus-circle"
                    v-if="inputObject.distanceTier[idx].weight.length > 1"
                  ></i>
                  <i class="fa fa-plus-circle" v-else></i>
                </b-button>
                <b-button
                  v-if="
                    wIdx > 0 &&
                    wIdx === inputObject.distanceTier[idx].weight.length - 1
                  "
                  btn-special="deliverybtn"
                  size="lg"
                  class="ml-3"
                  style="backgrount-color: #767bf1"
                  @click="onClickButton(idx, null, true)"
                >
                  <i class="fa fa-plus-circle"></i>
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </div>
        <hr class="mt-5" />
        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary mr-4"
            classic="mr-1 btn-primary"
            text="Update"
            :disabled="invalid"
            @click.prevent="handleSubmit"
          >
            Update
          </button>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import {
  ValidationProvider,
  ValidationObserver,
} from "vee-validate/dist/vee-validate.esm";
import cInput from "@/components/Common/CustomInput";
import ebSelect from "@/components/FormElements/Select.vue";
import moment from "moment";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
import currentUser from "@/mixins/currentUser";
export default {
  name: "EditDelivery",
  mixins: [currentUser],
  components: {
    ebButton,
    cInput,
    ValidationProvider,
    ValidationObserver,
    ebSelect,
  },
  data: () => {
    return {
      setPlaceHolder: "",
      deliveryPartnerKeyCheck: false,
      deliveryByMe: true,
      selectDeliveryPartner: "",
      checkDefaultCity: false,
      checkDefaultState: false,
      checkDefaultSourceCity: false,
      checkDefaultSourceState: false,
      uomList: ["days", "minutes", "hours"],
      show: true,
      inputObject: {
        sourceState: "",
        sourceCity: "",
        city: "",
        city: "",
        category: "",
        transportMode: "",
        startDate: "",
        endDate: "",
        rank: "",
        areacode: "",
        dwf: "",

        distanceTier: [
          {
            tier: "",
            from: "",
            to: "",
            isRemovable: true,
            weight: [
              {
                from: "",
                to: "",
                customerFee: "",
                deliveryAgentFee: "",
                isRemovable: true,
                etd: {
                  time: "",
                  uom: "",
                },
              },
            ],
          },
        ],
      },
      catalogList: [],
      transportmode: [
        {
          label: "Air ",
          value: "AIR",
        },
        {
          label: "Ship ",
          value: "SHIP",
        },
        {
          label: "Truck ",
          value: "TRUCK",
        },
        {
          label: "Bike ",
          value: "BIKE",
        },
      ],
    };
  },
  props: {
    details: {
      type: Object,
      required: true,
    },
  },
  watch: {
    checkDefaultState() {
      this.inputObject.state = "*";
    },
    checkDefaultCity() {
      this.inputObject.city = "*";
    },
    checkDefaultSourceState() {
      this.inputObject.sourceState = "*";
    },
    checkDefaultSourceCity() {
      this.inputObject.sourceCity = "*";
    },
  },
  computed: {
    ...mapGetters({
      provider: "auth/getUserID",
    }),
    deliveryPartnerOptions() {
      try {
        let data = this.$store.getters["partner/GetPartnerList"];
        let partnerData = [];
        if (Array.isArray(data) && data.length > 0) {
          data.map((obj) => {
            partnerData.push({
              _id: obj._id,
              name: obj.authentication.userName,
              email: obj.authentication.email,
              phone: obj.authentication.phone,
              category: obj.category,
            });
          });
          return partnerData;
        } else {
          return [];
        }
      } catch {
        return [];
      }
    },
    userRole() {
      if (this.$store.getters["auth/getUserRole"]) {
        return this.$store.getters["auth/getUserRole"];
      } else {
        return JSON.parse(sessionStorage.getItem("userLogin"))["role"];
      }
    },
  },
  methods: {
    async getCatalogName() {
      let result = [];
      if (this.$userRole == "Tenant") {
        result = await this.$store.getters["catalog/GetTenantCatalogTree"];
      } else if (this.$userRole == "Partner") {
        result = this.$store.getters["catalog/GetPartnerCatalogTree"];
      }
      this.catalogList = result
        .filter((Obj) => Obj.isProductType)
        .map((c) => ({ text: c.name, value: c._id }));
      this.catalogList.push({ text: "All Categories", value: "*" });
      this.catalogList.reverse();
    },
    async onClickaddButton(idx, add = false) {
      if (this.inputObject.distanceTier.length > 1 && !add) {
        this.inputObject.distanceTier.splice(idx, 1);
      } else {
        this.inputObject.distanceTier.push({
          tier: "",
          from: "",
          to: "",
          weight: [
            {
              from: "",
              to: "",
              customerFee: "",
              deliveryAgentFee: "",
              etd: {
                time: "",
                uom: "",
              },
            },
          ],
        });
      }
    },
    async onClickButton(idx, wIdx, add = false) {
      if (this.inputObject.distanceTier[idx].weight.length > 1 && !add) {
        this.inputObject.distanceTier[idx].weight.splice(wIdx, 1);
      } else {
        this.inputObject.distanceTier[idx].weight.push({
          from: "",
          to: "",
          customerFee: "",
          deliveryAgentFee: "",
          isRemovable: true,
          etd: {
            time: "",
            uom: "",
          },
        });
      }
    },

    async handleSubmit() {
      let dataObj;
      dataObj = {
        id: this.$props.details._id,
        data: {
          _id: this.$props.details._id,
          tenant: this.$props.details.tenant,
          status: this.inputObject.status,
          rank: this.inputObject.rank,
          state: this.inputObject.state,
          sourceState: this.inputObject.sourceState,
          startDate: this.inputObject.startDate,
          endDate: this.inputObject.endDate,
          category: this.inputObject.category.value,
          transportMode: this.inputObject.transportMode.value,
          city: this.inputObject.city,
          sourceCity: this.inputObject.sourceCity,
          dwf: this.inputObject.dwf,
          areaCode: this.inputObject.areacode,
          distanceTier: this.inputObject.distanceTier,
        },
      };

      if (this.deliveryByMe) {
        dataObj.data.deliveryOwner = {
          _id: this.$currentUserData._id,
          name: this.$currentUserData.userName,
          email: this.$currentUserData.email,
          phone: this.$currentUserData.phone,
          category:
            this.$currentUserData.category == "TA"
              ? "TENANT"
              : this.$currentUserData.category,
        };
      } else {
        try {
          dataObj.data.deliveryOwner = {
            _id: this.selectDeliveryPartner._id,
            name: this.selectDeliveryPartner.name,
            email: this.selectDeliveryPartner.email,
            phone: this.selectDeliveryPartner.phone,
            category: this.selectDeliveryPartner.category,
          };
        } catch {}
      }
      dataObj.data.distanceTier.forEach((obj) => {
        delete obj.isRemovable;
        obj.weight.forEach((element) => {
          delete element.isRemovable;
        });
      });
      if (this.checkDefaultState) {
        dataObj.data.state = "*";
      } else {
      }

      if (this.checkDefaultCity) {
        dataObj.data.city = "*";
      } else {
      }

      if (this.checkDefaultSourceState) {
        dataObj.data.sourceState = "*";
      } else {
      }

      if (this.checkDefaultSourceCity) {
        dataObj.data.sourceCity = "*";
      } else {
      }

      if (this.checkDefaultCity) {
        dataObj.data.city = "*";
      } else {
      }
      const response = await this.$store
        .dispatch("delivery/updateDeliverySetup", dataObj)
        .then((result) => {
          console.log("result", result);
          this.$swal({
            title: "Success",
            text: "Delivery setup details Updated successfully!!",
            type: "success",
          });
          this.$emit("edit", {});
        })
        .catch((err) => {
          console.log("err", err);

          this.$swal({
            title: "Opps!!!!!!",
            text: "Sorry Unable to Update Delivery setup!!",
            type: "error",
          });
        });

      this.$store.dispatch("delivery/fetchdeliverysList");
    },
  },
  async mounted() {
    if (this.$userRole == "Tenant") {
      if (!this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchTenantCatalogTree");
      } else {
      }
    } else if (this.$userRole == "Partner") {
      if (!this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        await this.$store.dispatch("catalog/fetchPartnerCatalogTree");
      } else {
      }
    }

    this.getCatalogName();

    if (this.$userRole == "Tenant") {
      await this.$store.dispatch(
        "partner/listPartnerTypeFilterAction",
        "DISTRIBUTOR"
      );
      this.setPlaceHolder = "Distributor";
    } else if (this.$userRole == "Partner") {
      if (this.$currentUserData.category == "DISTRIBUTOR") {
        await this.$store.dispatch(
          "partner/listPartnerTypeFilterAction",
          "DEALER"
        );
        this.setPlaceHolder = "Dealer";
      } else if (this.$currentUserData.category == "DEALER") {
        await this.$store.dispatch(
          "partner/listPartnerTypeFilterAction",
          "SELLER"
        );
        this.setPlaceHolder = "Seller";
      } else if (this.$currentUserData.category == "SELLER") {
        this.deliveryPartnerKeyCheck = true;
      }
    }

    if (this.$props.details.deliveryOwner) {
      try {
        if (
          this.$props.details.deliveryOwner._id == this.$currentUserData._id
        ) {
          this.deliveryByMe = true;
        } else {
          this.deliveryByMe = false;
        }

        this.selectDeliveryPartner = {
          _id: this.$props.details.deliveryOwner._id,
          name: this.$props.details.deliveryOwner.name,
          email: this.$props.details.deliveryOwner.email,
          phone: this.$props.details.deliveryOwner.phone,
          category: this.$props.details.deliveryOwner.category,
        };
      } catch {}
    } else {
    }

    if (this.$userRole == "Tenant") {
      if (this.$store.getters["catalog/GetTenantCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetTenantCatalogTree"
        ].filter((obj) => {
          return this.$props.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = {
            text: filtredList[0].name ? filtredList[0].name : "*",
            value: filtredList[0]._id ? filtredList[0]._id : "*",
          };
        } else {
          this.inputObject.category = {
            text: "All categories",
            value: "*",
          };
        }
      }
    } else if (this.$userRole == "Partner") {
      if (this.$store.getters["catalog/GetPartnerCatalogTree"].length > 0) {
        let filtredList = this.$store.getters[
          "catalog/GetPartnerCatalogTree"
        ].filter((obj) => {
          return this.$props.details.category_id == obj._id;
        });

        if (filtredList.length > 0) {
          this.inputObject.category = {
            text: filtredList[0].name ? filtredList[0].name : "*",
            value: filtredList[0]._id ? filtredList[0]._id : "*",
          };
        } else {
          this.inputObject.category = {
            text: "All categories",
            value: "*",
          };
        }
      }
    }
  },
  async created() {
    this.inputObject.city = this.$props.details.city;
    if (this.inputObject.city == "*") {
      this.checkDefaultCity = true;
    } else {
    }

    this.inputObject.sourceCity = this.$props.details.sourceCity
      ? this.$props.details.sourceCity
      : "";
    if (this.inputObject.sourceCity == "*") {
      this.checkDefaultSourceCity = true;
    } else {
    }
    //this.inputObject.category = this.$props.details.category;
    this.inputObject.startDate = moment(
      String(new Date(this.$props.details.startDate))
    ).format("yyyy-MM-DD");

    this.inputObject.endDate = moment(
      String(
        new Date(
          this.$props.details.endDate ? this.$props.details.endDate : "Invalid"
        )
      )
    ).format("yyyy-MM-DD");
    // this.$props.details.EndDate
    this.inputObject.state = this.$props.details.state;
    if (this.inputObject.state == "*") {
      this.checkDefaultState = true;
    } else {
    }

    this.inputObject.sourceState = this.$props.details.sourceState
      ? this.$props.details.sourceState
      : "";
    if (this.inputObject.sourceState == "*") {
      this.checkDefaultSourceState = true;
    } else {
    }
    this.inputObject.rank = this.$props.details.rank + "";
    this.inputObject.dwf = this.$props.details.dwf + "";
    this.inputObject.areacode = this.$props.details.areaCode;
    this.inputObject.distanceTier = this.$props.details.distance;
    this.inputObject.transportMode = {
      label: this.$props.details.transportMode,
      value: this.$props.details.transportMode,
    };
    var distanceCount = 1;

    if (this.inputObject.distanceTier != null) {
      this.inputObject.distanceTier.map((e) => {
        if (distanceCount === 1) {
          e.isRemovable = false;
        } else {
          e.isRemovable = true;
        }
        var weightCount = 1;
        e.weight.map((s) => {
          s.customerFee = s.customerFee.toString();
          s.deliveryAgentFee = s.deliveryAgentFee.toString();
          s.from = s.from.toString();
          s.to = s.to.toString();
          if (s.etd) {
            s.etd = s.etd;
            if (s.etd.time) {
              s.etd.time = s.etd.time.toString();
            }
          } else {
            s.etd = {
              time: "",
              uom: "",
            };
          }
          if (weightCount === 1) {
            s.isRemovable = false;
          } else {
            s.isRemovable = true;
          }
          weightCount++;
        });
        distanceCount++;
      });
    }
  },
};
</script>
<style scoped>
.fa-plus {
  border-top-right-radius: 10px;
  border-top-left-radius: 17px;
  border-bottom-left-radius: 17px;
  background-color: #f0f3f5;
}

.hide {
  display: none;
  font-size: 11px;
}
.back-button {
  color: white;
  font-weight: bold;
  float: right;
}
.input {
  background: #767bf1;
  color: #767bf1;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
[btn-special="deliverybtn"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 36px;
  width: 44px;
  background-color: #727cf5;
  color: white;
}
</style>
